import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-917c6e3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "menu-item" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "menu-item-content" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 退出 ")

import Footer from '@/components/Footer.vue'
import store from '@/lib/store'
import { DownOutlined, LogoutOutlined } from '@ant-design/icons-vue'
import { StoreSessionMutations } from '@/lib/store/modules/session/mutations'
import { computed, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { IIdCard, ShopRole } from '@/interface'
import { StoreCashierActions } from '@/lib/store/modules/cashier/actions'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const session = store.state.session
const idCard = computed((): IIdCard => session.id_cards[session.id_cards_index])
const idCards = computed((): IIdCard[] => store.state.session.id_cards.filter(s => s.shop.sid !== idCard.value.shop.sid))
const router = useRouter()
const sync = new BroadcastChannel('sync')

const topic = (key: string): string => {
  if (key.startsWith('http')) {
    return key
  } else {
    return `https://c.s.mywsy.cn/${key}-sq.200`
  }
}

const handleWorkspace = () => {
  router.push({ name: 'workspace' })
}

const handleSwapShop = (idCard: IIdCard) => {
  store.commit(StoreSessionMutations.join, idCard)
  store.dispatch(StoreCashierActions.onJoin, idCard)
  if (router.currentRoute.value.name !== 'workspace') router.push({ name: 'workspace' })
  sync.postMessage(idCard)
}

const handleLogout = () => {
  store.commit(StoreSessionMutations.logout)
  router.push({ name: 'login' })
}

onUnmounted(() => sync.close())


return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: topic(_unref(idCard).shop.icon)
            }, null, 8, _hoisted_2),
            (_unref(idCards).length === 0)
              ? (_openBlock(), _createElementBlock("h1", {
                  key: 0,
                  onClick: handleWorkspace
                }, _toDisplayString(_unref(idCard).shop.shop_name), 1))
              : (_openBlock(), _createBlock(_component_a_dropdown, { key: 1 }, {
                  overlay: _withCtx(() => [
                    _createVNode(_component_a_menu, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(idCards), (s, k) => {
                          return (_openBlock(), _createBlock(_component_a_menu_item, {
                            key: k,
                            onClick: ($event: any) => (handleSwapShop(s))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("img", {
                                  src: topic(s.shop.icon)
                                }, null, 8, _hoisted_5),
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("p", null, _toDisplayString(s.shop.shop_name), 1),
                                  _createElementVNode("p", null, _toDisplayString(s.shop.sid) + " [" + _toDisplayString(s.creator.role === _unref(ShopRole).Boss ? '老板' : s.creator.privilege_data ? '股东' : '收银员') + "]", 1)
                                ])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("h1", {
                      class: "ant-dropdown-link",
                      onClick: _withModifiers(handleWorkspace, ["prevent"])
                    }, [
                      _createTextVNode(_toDisplayString(_unref(idCard).shop.shop_name) + " ", 1),
                      _createVNode(_unref(DownOutlined))
                    ], 8, _hoisted_3)
                  ]),
                  _: 1
                })),
            _createElementVNode("div", {
              class: "logout",
              onClick: handleLogout
            }, [
              _createVNode(_unref(LogoutOutlined)),
              _hoisted_7
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, { style: {"text-align":"center"} }, {
        default: _withCtx(() => [
          _createVNode(Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})